import { useEffect, useRef, useContext } from 'react'
import { Context as LoadingContext } from '@/context/loading'

const LazyImage = ({
  className,
  src,
  height,
  width,
  alt,
  ...rest
}) => {
  const { ready } = useContext(LoadingContext)
  const $img = useRef(null)

  useEffect(() => {
    if (ready && $img.current) {
      $img.current.setAttribute('src', $img.current.getAttribute('data-src'))
      $img.current.addEventListener('load', () => $img.current.removeAttribute('data-src'))
    }
  }, [ready])

  return (
    <img
      ref={$img}
      className={className}
      data-src={src}
      alt={alt}
      {...rest} // eslint-disable-line
    />
  )
}

LazyImage.defaultProps = {
  alt: '',
}

export default LazyImage
